import { LazyRoute } from '@app/components/lazy-route';
import React, { lazy } from 'react';

const ExperienceDetailsPage = lazy(() => import('./experience-details-page'));

const ExperienceDetails = () => {
  return (
    <LazyRoute>
      <ExperienceDetailsPage />
    </LazyRoute>
  );
};

export { ExperienceDetails };
